import Image from 'next/image';
import React from 'react';
import { useTranslations } from '../../../locales/useTranslations';
import FadeInAnimation from "../../Common/FadeInAnimation";

const WordpressUnterstützung = () => {
    const { t } = useTranslations();


    return (
        <section className="about-area ptb-100" style={{
            background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Dekorative Hintergrund-Elemente */}
            <div style={{
                position: 'absolute',
                top: '10%',
                right: '5%',
                width: '200px',
                height: '200px',
                background: 'linear-gradient(135deg, rgba(89, 189, 101, 0.08), rgba(76, 175, 80, 0.08))',
                borderRadius: '50%',
                filter: 'blur(40px)',
                zIndex: '1'
            }}></div>

            <div style={{
                position: 'absolute',
                bottom: '20%',
                left: '10%',
                width: '150px',
                height: '150px',
                background: 'linear-gradient(135deg, rgba(8, 10, 60, 0.06), rgba(26, 28, 74, 0.06))',
                borderRadius: '50%',
                filter: 'blur(30px)',
                zIndex: '1'
            }}></div>

            <div className="container" style={{ position: 'relative', zIndex: '2' }}>
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <FadeInAnimation direction="left" delay={100}>
                            <div className="about-content">
                                <div style={{
                                    display: 'inline-block',
                                    background: 'linear-gradient(135deg, #59bd65, #4CAF50)',
                                    color: 'white',
                                    padding: '12px 30px',
                                    borderRadius: '30px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px',
                                    marginBottom: '25px',
                                    boxShadow: '0 8px 25px rgba(89, 189, 101, 0.3)'
                                }}>
                                    {t('wordpressSupport_support_subtitle')}
                                </div>

                                <h2 style={{
                                    fontSize: '2.8rem',
                                    fontWeight: '700',
                                    background: 'linear-gradient(135deg, #080a3c, #1a1c4a)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    marginBottom: '25px',
                                    lineHeight: '1.2'
                                }}>
                                    {t('wordpressSupport_support_title')}
                                </h2>

                                <div style={{
                                    background: 'white',
                                    borderRadius: '20px',
                                    padding: '30px',
                                    boxShadow: '0 15px 40px rgba(0, 0, 0, 0.1)',
                                    border: '1px solid rgba(89, 189, 101, 0.1)',
                                    marginBottom: '30px'
                                }}>
                                    <p style={{
                                        fontSize: '1.1rem',
                                        color: '#333',
                                        lineHeight: '1.7',
                                        marginBottom: '15px'
                                    }}>
                                        {t('wordpressSupport_support_description')}
                                    </p>
                                    <p style={{
                                        fontSize: '1.1rem',
                                        color: '#333',
                                        lineHeight: '1.7',
                                        marginBottom: '15px'
                                    }}>
                                        {t('wordpressSupport_support_description2')}
                                    </p>
                                    <p style={{
                                        fontSize: '1.1rem',
                                        color: '#333',
                                        lineHeight: '1.7',
                                        marginBottom: '15px'
                                    }}>
                                        {t('wordpressSupport_support_description3')}
                                    </p>
                                    <p style={{
                                        fontSize: '1.1rem',
                                        color: '#333',
                                        lineHeight: '1.7',
                                        marginBottom: '0'
                                    }}>
                                        {t('wordpressSupport_support_description4')}
                                    </p>
                                </div>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <FadeInAnimation direction="right" delay={200}>
                            <div className="about-image" style={{ position: 'relative' }}>
                                <div style={{
                                    background: 'white',
                                    borderRadius: '25px',
                                    padding: '20px',
                                    boxShadow: '0 25px 70px rgba(0, 0, 0, 0.15)',
                                    border: '1px solid rgba(89, 189, 101, 0.1)',
                                    transform: 'perspective(1000px) rotateY(-5deg)',
                                    transition: 'all 0.3s ease',
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    {/* Dekorative Elemente */}
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        right: '-30px',
                                        width: '100px',
                                        height: '100px',
                                        background: 'linear-gradient(135deg, rgba(89, 189, 101, 0.1), rgba(76, 175, 80, 0.1))',
                                        borderRadius: '50%',
                                        filter: 'blur(25px)',
                                        zIndex: '1'
                                    }}></div>

                                    <div style={{ position: 'relative', zIndex: '2' }}>
                                        <Image
                                            src="/images/web-development/wordpressLaptop.webp"
                                            alt="Simplify Data - Wordpress Betreuung"
                                            width={400}
                                            height={400}
                                            style={{
                                                borderRadius: '20px',
                                                width: '100%',
                                                height: 'auto'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .about-image:hover > div {
                    transform: perspective(1000px) rotateY(-3deg) scale(1.02) !important;
                }
                
                .col-md-6 > div:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 20px 50px rgba(89, 189, 101, 0.15) !important;
                }
                
                @media (max-width: 768px) {
                    h2 {
                        font-size: 2.2rem !important;
                    }
                    
                    .about-image {
                        margin-top: 40px;
                    }
                }
            `}</style>
        </section>
    );
}

export default WordpressUnterstützung;